export default (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 16C3.588 16 0 12.411 0 8C0 3.588 3.588 0 8 0C12.412 0 16 3.588 16 8C16 12.412 12.412 16 8 16ZM7.3245 10.805L11.811 6.135C12.061 5.875 12.061 5.455 11.821 5.195C11.571 4.935 11.1715 4.935 10.9215 5.195L6.885 9.395L5.0865 7.515C4.8365 7.255 4.437 7.255 4.187 7.515C3.937 7.775 3.937 8.1945 4.187 8.455L6.425 10.805C6.675 11.065 7.0745 11.065 7.3245 10.805Z"
      fill="#448ABF"
    />
  </svg>
);
